import { A_Error } from "@adaas/a-concept"



export class AreInstructionError extends A_Error{
    
}